import RequestManager from "./request-manager";
import { markLoadTime } from "./rum";
/**
 * Convenience function to set up hooks that send the RUM beacon at the appropriate time.
 */
export default function installSpeedCurveRumHooks() {
    RequestManager.onAllRequestsComplete(() => {
        markLoadTime();
        performance.mark("RequestManager.allRequestsComplete");
    });
}
